// extracted by mini-css-extract-plugin
module.exports = {"button":"_2gh_n","icon":"_3OVfN","facebook":"_1FglY","twitter":"LHvCi","link":"TcB0g","share":"_2HBxV"};